import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m0 5.66h-10a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1v-4a1 1 0 0 0 -1 -1","key":"svg-0"}]]

const IconCircleRectangleFilled = createReactComponent('filled', 'circle-rectangle-filled', 'CircleRectangleFilled', __iconNode);

export default IconCircleRectangleFilled;